module.exports = __webpack_public_path__ + "img/04.0d9d5504.jpg";